import { ResolvedPlaceDataSubmission } from "../../types/Place";
import AdminSubmissionReviewCard from "./AdminSubmissionReviewCard";
import PlaceSubmissionVewCard from "./PlaceSubmissionVewCard";
import "./SubmissionReviewCard.scss";

interface SubmissionReviewCardProps {
  submission: ResolvedPlaceDataSubmission;
  isAdmin: boolean;
  context: "global" | "place";
}

export default function SubmissionReviewCard({
  submission,
  context,
  isAdmin,
}: SubmissionReviewCardProps) {
  if (context === "global") {
    if (isAdmin) {
      return <AdminSubmissionReviewCard submission={submission} />;
    }

    return <div>Not Authorized</div>;
  }

  return <PlaceSubmissionVewCard submission={submission} />;
}
